import httpService from "./httpService";

export interface ProductShareData {
  title: string;
  description: string;
  createdAt: string;
  totalStocks?: number;
  totalLongStocks?: number;
  totalShortStocks?: number;
  totalBaskets?: number;
  totalLongBaskets?: number;
  totalShortBaskets?: number;
  totalOptions?: number;
  totalLongOptions?: number;
  totalShortOptions?: number;
  totalHoldings?: number;
  totalLongHoldings?: number;
  totalShortHoldings?: number;
}

export interface ProductShare {
  id: number;
  providerId: number;
  productType: "BASKET" | "PORTFOLIO";
  productId: number;
  token: string;
  data: ProductShareData;
  updatedAtUtc: string;
  ogImageGeneratedAtUtc: string | null;
}

interface ProductShareResponse {
  data: ProductShare;
}

class ProductShareService {
  async getShare(
    productType: "BASKET" | "PORTFOLIO",
    productId: number
  ): Promise<ProductShare | null> {
    try {
      const response = await httpService.get<ProductShareResponse>(
        `v3/products/shares/${productType}/${productId}`
      );
      return response.data.data;
    } catch (error: any) {
      if (error?.response?.status === 404) return null;
      throw error;
    }
  }

  async regenerateToken(
    productType: "BASKET" | "PORTFOLIO",
    productId: number
  ): Promise<ProductShare> {
    const response = await httpService.post<ProductShareResponse>(
      `v3/products/shares/${productType}/${productId}/new-token`
    );
    return response.data.data;
  }
}

export const productShareService = new ProductShareService();
